import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { IUserMast } from "../../models/UserMast";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useRef } from "react";
import { JVInput } from "../../shared/JVInput";
import { Toast } from "primereact/toast";
import { Fetch } from "../../shared/Fetch";
import { useNavigate } from "react-router-dom"; // Import useNavigate

const EmptyUser = {
  login_ID: undefined,
  user_Name: "",
  login_Name: "",
  user_EmailID: "",
  user_Cell_No: "",
  branch_ID: 0,
  branchName: "",
  user_Status: true,
  temp_Inactive: false,
  login_Password: "",
  user_PhoneNo: "",
  user_Ext_No: "",
  user_GtalkID: "",
  user_YahooID: "",
  workFrom: "",
  date_Of_Joining: null,
  experience_In_Month: null,
  user_Type: null,
};

const schema = yup.object({
  user_Name: yup.string().required("UserName is required*").min(3),
  login_Name: yup.string().required("LoginName is required*").min(3),
  user_EmailID: yup.string().required("UserEmailID is required*").email(),
  login_Password: yup
    .string()
    .required("loginPassword is required*")
    .min(6)
    .max(16),
});

export const UserProfile = () => {
  const toast = useRef<any>(null);
  const navigate = useNavigate(); // Initialize useNavigate hook

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IUserMast>({
    resolver: yupResolver(schema),
    defaultValues: EmptyUser,
    shouldFocusError: false,
  });

  useEffect(() => {
    (async () => {
      const response = await Fetch(
        `External_User_Mast/me`,
        "GET",
        null,
        null,
        toast
      );
      if (response) {
        const data: IUserMast = await response.json();
        reset(data);
      }
    })();
  }, []);

  const saveToDB = async (body: IUserMast) => {
    const response = await Fetch(
      "External_User_Mast/password",
      "PUT",
      body,
      null,
      toast
    );
    if (response) {
      toast.current.show({
        severity: "success",
        detail: "Password Updated Successfully",
        life: 3000,
      });
    }
  };

  function onSubmit(data: IUserMast) {
    saveToDB(data);
  }

  const goToDashboard = () => {
    navigate("/dashboard"); // Navigate to the dashboard route
  };

  return (
    <>
      <div className="col-12 md:col-2">
        <Button
          className="field col-12 md:col-12 sm:col-12"
          label="Go to Dashboard"
          onClick={goToDashboard}
          icon="pi pi-arrow-left"
        />
      </div>
      <Card title="Update Password" style={{ width: "80vw" }}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="p-fluid formgrid grid"
        >
          <JVInput
            disabled
            label="Name"
            control={control}
            name="user_Name"
            error={errors.user_Name?.message}
          />
          <JVInput
            disabled
            label="Email"
            control={control}
            name="user_EmailID"
            error={errors.user_EmailID?.message}
          />
          <JVInput
            disabled
            label="LoginID"
            control={control}
            name="login_Name"
            error={errors.login_Name?.message}
          />
          <JVInput
            required
            disabled
            label="Password"
            control={control}
            name="login_Password"
            error={errors.login_Password?.message}
          />
          <div className="col-12 md:col-12">
            <Button
              className="field col-12 md:col-6"
              label="SAVE"
              type="submit"
            ></Button>
          </div>
        </form>
        <Toast ref={toast} />
      </Card>
    </>
  );
};
